// extracted by mini-css-extract-plugin
export default {"methodInputContainer":"MethodInputQuestion_methodInputContainer__hUCCW"};